import request from '../utils/request';

export const getArticleList = (data) => {
  return request.post('/jeecg-boot/jishi/cms/article/list', data);
};

export const getNewsDetail = (id) => {
  return request.get(`/jeecg-boot/jishi/cms/article/detail?id=${id}`);
};